// extracted by mini-css-extract-plugin
module.exports = {"check":"Questionario_check__20hw4"};